import React from 'react';
import './NavBar.css';
// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import 'rsuite/styles/index.less'; // or 'rsuite/dist/rsuite.min.css'
import 'rsuite/Sidenav/styles/index.css';
import 'rsuite/Nav/styles/index.css';
import logo from '../../Images/logo.png';
import { Link } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import BigButton from '../../Component/BigButton';
import LogoutIcon from '@mui/icons-material/Logout';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import Tooltip from '@mui/material/Tooltip';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import GroupIcon from '@mui/icons-material/Group';
import passtext from '../../Images/passtext.png';
import AssessmentSharpIcon from '@mui/icons-material/AssessmentSharp';
import CampaignIcon from '@mui/icons-material/Campaign';
import { SyncContext, SyncContextType } from '../../Contexts/BatchSyncContext';
import GroupsIcon from '@mui/icons-material/Groups';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CurrencyExchangeSharpIcon from '@mui/icons-material/CurrencyExchangeSharp';
import LowPrioritySharpIcon from '@mui/icons-material/LowPrioritySharp';
import { Diversity3, EditNoteSharp } from '@mui/icons-material';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import { RiCoinsLine } from "react-icons/ri";
import { FaCoins } from "react-icons/fa";
import { RiHandCoinFill } from "react-icons/ri";
import { TbReportMoney } from "react-icons/tb";
import { GiPayMoney } from "react-icons/gi";
import { FaMoneyCheckAlt } from "react-icons/fa";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';




interface NavBarLeftProps { }
interface NavBarLeftState {
    expanded: boolean;
    activeKey: string;
    activeUrl: string;
    isToggled: boolean;
}

class NavBarLeft extends React.Component<NavBarLeftProps, NavBarLeftState> {
    static contextType = SyncContext;
    context!: SyncContextType;
    constructor(props_: NavBarLeftProps) {
        super(props_);

        this.state = {
            expanded: true,
            activeKey: "1",
            activeUrl: '',
            isToggled: true
        }

        window.addEventListener("popstate", () => {
            this.setState({
                activeUrl: window.location.pathname
            });
        });
    }


    public render() {
        const { state } = this.context
        const { permissions } = state;
        return (
            <div className={`nav-container ` + (this.state.isToggled ? 'active' : '')}>
                <div className='menu-toggle' onClick={() => {
                    this.setState({
                        isToggled: !this.state.isToggled
                    });
                }}>{
                        this.state.isToggled ? <KeyboardArrowRightIcon fontSize='large' /> : <KeyboardArrowLeftIcon fontSize='large' />}</div>
                <div className='logo-container'>
                    <div><img src={logo} alt="Logo" className="app-logo" /></div>
                    <div className='app-title'><img src={passtext} alt="Logo" /></div>
                </div>
                <div className='menu-container'>
                    {permissions.dashboard?.isVisible && (
                        <Tooltip title="Dashboard">
                            <Link to="/dashboard" className={this.isSelected('dashboard')} onClick={() => { this.setActiveUrl('dashboard') }}>
                                <div className='menu-item'><DashboardIcon /> <span>Dashboard</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.transactionLogs?.isVisible && (
                        <Tooltip title="Transaction Logs">
                            <Link to="/transactionlogs" className={this.isSelected('transactionlogs')} onClick={() => { this.setActiveUrl('transactionlogs') }}>
                                <div className='menu-item'><BackupTableIcon /> <span>Transaction Logs</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.userLogs?.isVisible && (
                        <Tooltip title="User Actions">
                            <Link to="/useractions" className={this.isSelected('useractions')} onClick={() => { this.setActiveUrl('useractions') }}>
                                <div className='menu-item'><WorkHistoryIcon /> <span>User Actions</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.complianceLogs?.isVisible && (
                        <Tooltip title="Compliance">
                            <Link to="/compliance" className={this.isSelected('compliance')} onClick={() => { this.setActiveUrl('compliance') }}>
                                <div className='menu-item'><AssuredWorkloadIcon /> <span>Compliance</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.userDetails?.isVisible && (
                        <Tooltip title="User Details">
                            <Link to="/userdetails" className={this.isSelected('userdetails')} onClick={() => { this.setActiveUrl('userdetails') }}>
                                <div className='menu-item'><ManageAccountsIcon /> <span>User Details</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.userTransactionReport?.isVisible && (
                        <Tooltip title="Reports">
                            <Link to="/userreports" className={this.isSelected('userreports')} onClick={() => { this.setActiveUrl('userreports') }}>
                                <div className='menu-item'><AssessmentSharpIcon /> <span>User Reports</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.promoCode?.isVisible && (
                        <Tooltip title="Promotionals">
                            <Link to="/promocode" className={this.isSelected('promocode')} onClick={() => { this.setActiveUrl('promocode') }}>
                                <div className='menu-item'><LocalOfferIcon /> <span>Promotionals</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.exchangeRates?.isVisible && (
                        <Tooltip title="Exchange Rate">
                            <Link to="/exchangerate" className={this.isSelected('exchangerate')} onClick={() => { this.setActiveUrl('exchangerate') }}>
                                <div className='menu-item'><CurrencyExchangeSharpIcon /> <span>Exchange Rate</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.referrals?.isVisible && (
                        <Tooltip title="Referrals">
                            <Link to="/referral" className={this.isSelected('referral')} onClick={() => { this.setActiveUrl('referral') }}>
                                <div className='menu-item'><GroupsIcon /> <span>Referrals</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.chargeBack?.isVisible && (
                        <Tooltip title="Chargeback">
                            <Link to="/chargeback" className={this.isSelected('chargeback')} onClick={() => { this.setActiveUrl('chargeback') }}>
                                <div className='menu-item'><LowPrioritySharpIcon /> <span>Chargebacks</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.partner?.isVisible && (
                        <Tooltip title="Partners">
                            <Link to="/partner" className={this.isSelected('partner')} onClick={() => { this.setActiveUrl('partner') }}>
                                <div className='menu-item'><Diversity3 /> <span>Partners</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.fxAllocation?.isVisible && (
                        <Tooltip title="FX Pools" >
                            <Link to="/fxpools" className={this.isSelected('fxpools')} onClick={() => { this.setActiveUrl('fxpools') }}>
                                <div className='menu-item'><TbReportMoney size={25} /> <span>FX Pools</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {permissions.fxAllocation?.isVisible && (
                        <Tooltip title="FX Allocations" >
                            <Link to="/fxallocations" className={this.isSelected('fxallocations')} onClick={() => { this.setActiveUrl('fxallocations') }}>
                                <div className='menu-item'><GiPayMoney size={25} /> <span>FX Allocations</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {(
                        <Tooltip title="Placeholder Rate Reconciliation">
                            <Link to="/ratereconciliation" className={this.isSelected('ratereconciliation')} onClick={() => { this.setActiveUrl('ratereconciliation') }}>
                                <div className='menu-item'><RiHandCoinFill size={22} /> <span>Placeholder Rate <br /> Reconciliation</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {(
                        <Tooltip title="FX Reports">
                            <Link to="/fxreports" className={this.isSelected('fxreports')} onClick={() => { this.setActiveUrl('fxreports') }}>
                                <div className='menu-item'><FaMoneyCheckAlt size={25} /> <span>FX Reports</span></div>
                            </Link>
                        </Tooltip>
                    )}
                    {/* {(
                        <Tooltip title="Bankpartners">
                            <Link to="/bankpartners" className={this.isSelected('bankpartners')} onClick={() => { this.setActiveUrl('bankpartners') }}>
                                <div className='menu-item'><AccountBalanceIcon /> <span>Bank partners</span></div>
                            </Link>
                        </Tooltip>
                    )} */}

                </div>
                {/* <div>
                    <div style={{
                            display: 'inline-block',
                            float: 'inline-end'
                    }}>
                        <Link to="#" onClick={() => {
                            this.setState({
                                activeUrl: ''
                            }, () => {
                                localStorage.clear();
                                window.location.href = '/';
                            })

                        }}><div className='menu-item log-out'><LogoutIcon /> <span>Sign Out</span></div></Link>
                    </div>

                </div> */}


                {/* <Toggle
                    onChange={(value) => {
                        console.log(value);
                        this.setState({
                            expanded: value
                        })
                    }}
                    checked={this.state.expanded}
                    checkedChildren="Expand"
                    unCheckedChildren="Collapse"
                />
                <hr />
                <Sidenav expanded={this.state.expanded} defaultOpenKeys={['3', '4']}>
                    <Sidenav.Body>
                        <Nav activeKey={this.state.activeKey} onSelect={(key) => {
                            this.setState({
                                activeKey: key
                            })
                        }}>
                            <Nav.Item eventKey="1" icon={<DashboardIcon />}>
                                Dashboard
                            </Nav.Item>
                            <Nav.Item eventKey="2" icon={<GroupIcon />}>
                                User Group
                            </Nav.Item>
                            <Nav.Menu placement="rightStart" eventKey="3" title="Advanced" icon={<MagicIcon />}>
                                <Nav.Item eventKey="3-1">Geo</Nav.Item>
                                <Nav.Item eventKey="3-2">Devices</Nav.Item>
                                <Nav.Item eventKey="3-3">Loyalty</Nav.Item>
                                <Nav.Item eventKey="3-4">Visit Depth</Nav.Item>
                            </Nav.Menu>
                            <Nav.Menu
                                placement="rightStart"
                                eventKey="4"
                                title="Settings"
                                icon={<GearCircleIcon />}
                            >
                                <Nav.Item eventKey="4-1">Applications</Nav.Item>
                                <Nav.Item eventKey="4-2">Channels</Nav.Item>
                                <Nav.Item eventKey="4-3">Versions</Nav.Item>
                                <Nav.Menu eventKey="4-5" title="Custom Action">
                                    <Nav.Item eventKey="4-5-1">Action Name</Nav.Item>
                                    <Nav.Item eventKey="4-5-2">Action Params</Nav.Item>
                                </Nav.Menu>
                            </Nav.Menu>
                        </Nav>
                    </Sidenav.Body>
                    <Sidenav.Toggle onToggle={expanded => this.setState({
                        expanded: expanded
                    })} />
                </Sidenav> */}
            </div>
        )
    }

    private setActiveUrl(url: string) {
        this.setState({
            activeUrl: url
        })
    }

    private isSelected(screenName: string) {
        var url_ = window.location.href.replace(window.location.origin, '').replace('#', '');
        return url_.indexOf(`/${screenName}`) != -1 ? 'selected' : '';
    }
}

export default NavBarLeft;